import { render, staticRenderFns } from "./OurLeaders.vue?vue&type=template&id=6a6c9150&scoped=true"
import script from "./OurLeaders.vue?vue&type=script&lang=js"
export * from "./OurLeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c9150",
  null
  
)

export default component.exports